"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Button = _interopRequireDefault(require("@mui/material/Button"));
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _AlertBox = _interopRequireDefault(require("../../../domainless/feedback/AlertBox"));
var _validator = _interopRequireDefault(require("../../../../utils/validator"));
var _validationConstraints = require("./validationConstraints");
var _SNETForgotPassword = _interopRequireDefault(require("../SNETForgotPassword"));
var _SNETForgotPasswordConfirmModule = _interopRequireDefault(require("./SNETForgotPasswordConfirm.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SNETForgotPasswordConfirm = _ref => {
  let {
    email,
    title,
    description,
    forgotPasswordConfirmError,
    onSubmit
  } = _ref;
  const [localEmail, setLocalEmail] = (0, _react.useState)(email);
  const [code, setCode] = (0, _react.useState)("");
  const [password, setPassword] = (0, _react.useState)("");
  const [confirmPassword, setConfirmPassword] = (0, _react.useState)("");
  const [validationErr, setValidationErr] = (0, _react.useState)("");
  (0, _react.useEffect)(() => {
    if (email) {
      setLocalEmail(email.toLowerCase());
    }
  }, [email]);
  const handleSubmit = event => {
    event.preventDefault();
    setValidationErr("");
    const isNotValid = (0, _validator.default)({
      password,
      confirmPassword,
      code,
      localEmail
    }, _validationConstraints.forgotPassworSubmitConstraints);
    if (isNotValid) {
      setValidationErr(isNotValid[0]);
      return;
    }
    // Assuming the user state has the email, no need to explicitly pass it to this component
    onSubmit(localEmail, code, password);
  };
  const confirmFieldsData = [{
    id: "outlined-email-input",
    label: "Email",
    type: "email",
    name: "email",
    value: localEmail,
    onChange: setLocalEmail
  }, {
    id: "outlined-code-input",
    label: "Code",
    type: "code",
    name: "code",
    value: code,
    onChange: setCode
  }, {
    id: "outlined-new-password-input",
    label: "New Password",
    type: "password",
    name: "password",
    margin: "normal",
    value: password,
    onChange: setPassword
  }, {
    id: "outlined-confirm-password-input",
    label: "Confirm Password",
    type: "password",
    name: "password",
    value: confirmPassword,
    onChange: setConfirmPassword
  }];
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 24
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    item: true,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    className: _SNETForgotPasswordConfirmModule.default.forgotPwdContent
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "h3"
  }, title), /*#__PURE__*/_react.default.createElement(_Typography.default, null, description), /*#__PURE__*/_react.default.createElement("form", {
    className: _SNETForgotPasswordConfirmModule.default.forgotPwdForm
  }, confirmFieldsData.map(field => /*#__PURE__*/_react.default.createElement(_TextField.default, {
    key: field.id,
    id: field.id,
    label: field.label,
    className: _SNETForgotPasswordConfirmModule.default.textField,
    autoComplete: "off",
    type: field.type,
    name: field.name,
    margin: "normal",
    variant: "outlined",
    value: field.value,
    required: true,
    onChange: e => field.onChange(e.target.value)
  })), /*#__PURE__*/_react.default.createElement(_AlertBox.default, {
    type: "error",
    message: validationErr || forgotPasswordConfirmError
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    children: "reset password",
    type: "submit",
    onClick: handleSubmit
  }))));
};
SNETForgotPasswordConfirm.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  forgotPasswordConfirmError: _propTypes.default.string,
  onSubmit: _propTypes.default.func
};
_SNETForgotPassword.default.defaultProps = {
  title: "Reset your password",
  description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Thanks for confirming your email.", /*#__PURE__*/_react.default.createElement("span", null, "Input your new password"))
};
var _default = exports.default = SNETForgotPasswordConfirm;